/*
 * This script is used to add and update timers for products
 * that have a 'soon' tag as well as the correct countdown tag
 * referenced in Countdown Settings for Theme Settings.
 */

setInterval(() => {
    const countdownText = document.querySelector("body").dataset?.countdownText;

    const countdown = countdownData();
    let elementHTML = ``;
    document.querySelectorAll('.productTimerContainer').forEach((product) => {
        elementHTML = `
            <div class="square">
            <div class="day">${countdownText.length ? countdownText : checkAndPrependZero(countdown.day) +' '+ countdown.month }</div>
            </div>
            <div class="countdown">
        `;
            if(countdown.days)
                elementHTML += `<span class="days">${countdown.days}d</span>`;
            elementHTML += `<span class="hours">${checkAndPrependZero(countdown.hours)}</span>h`;
            elementHTML += `<span class="minutes">${checkAndPrependZero(countdown.minutes)}</span>m`;
            elementHTML += `<span class="seconds">${checkAndPrependZero(countdown.seconds)}</span>s`;
        elementHTML += `</div>`;
        product.innerHTML = elementHTML;
    })
},500);

function countdownData() {
    
    const timer = {
        countdown: document.querySelector("body").dataset?.countdown,
        tag: document.querySelector("body").dataset?.countdownTag
    }

    const timerDate = new Date(timer.countdown);
    
    let dateNotPassed = true;
    let currentDate = new Date();

    if(currentDate.getTime() > timerDate.getTime()){
        dateNotPassed = false;
    }
    let diffInMilliseconds = timerDate.getTime() - currentDate.getTime();

    let totalHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    let totalMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    let totalSeconds = Math.floor(diffInMilliseconds / 1000);

    let days = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    let hours = Math.floor((diffInMilliseconds - (days * 1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((diffInMilliseconds - (totalHours * 1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((diffInMilliseconds - (totalHours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000);
    
    let month = getMonthName(timerDate);

    return {
        day: timerDate.getDate(),
        month: month,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        totalHours: totalHours,
        totalMinutes: totalMinutes,
        totalSeconds: totalSeconds,
        timer: timer,
        dateNotPassed: dateNotPassed,
        currentDate: currentDate,
    };
}

// Get month name from date's month index.
function getMonthName(date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return monthNames[date.getMonth()];
}

// Checks if string contains 1 character. If it does, prepend a zero.
function checkAndPrependZero(str){
    if (str.toString().length === 1) {
        // Append a 0 to the string
        str = "0" + str;
    }

    // Return the string
    return str;
}